
// import listeningToUserActions from '@/utils/listeningToUserActions'
// 获取当前时间
let currentTime = new Date().getTime(), lastTime = new Date().getTime();

// 设置自动失效时长
// const diff = 1000 * 60 * 29;
const diff = 1000;
const outTime = 1000 * 60 * 29;
//监听视频是否 正在观看
const listeningToUserVideo = () => { 
    // 获取 video 元素
    const videoElement = document.querySelector('video');
    if (!videoElement) { 
        return
    }
    // 设置计数器和检查间隔帧数
    let counter = 0;
    const interval = 10;

    // 定义一个 checkVideoPlaying() 方法，用来检查视频是否正在播放
    const checkVideoPlaying = () => {
        counter++;
        // 如果计数器达到了指定的帧数，则进行检查
        if (counter >= interval) {
            // 如果视频正在播放并且页面处于可见状态，则说明用户正在观看视频
            if (!videoElement.paused && document.visibilityState === 'visible') {
                localStorage.setItem('last_Static_Operate_Time', Date.now().toString());
                // console.log('The user is watching the video.');
                lastTime = new Date().getTime()
            }
            // 重置计数器
            counter = 0;
        }
        // 使用递归调用函数的方式来进行循环检查
        window.requestAnimationFrame(checkVideoPlaying);
    };

    // 当视频开始播放时，调用 checkVideoPlaying() 方法
    videoElement.addEventListener('play', () => {
        // 开始检查视频是否正在播放
        checkVideoPlaying();
    });
  
}

// 重置最后一次操作的时间
function resetlastTime() {
    localStorage.setItem('last_Static_Operate_Time', Date.now().toString());
    // console.log('===========')
    listeningToUserVideo()
    lastTime = new Date().getTime()
}
export function listeningToUserActions(logout) {
    // 监听用户长时间不操作后自动退出登录
    // console.log("timer start", new Date().toLocaleTimeString());
    // 开启时间监听(鼠标移动、点击、键盘点击)
    document.addEventListener('mouseover', resetlastTime, true);
    document.addEventListener('keydown', resetlastTime, true);
    document.addEventListener('mousedown', resetlastTime, true);
    // 开启定时器
    const Timer = setInterval(async function () {
        currentTime = new Date().getTime();
        if (currentTime - lastTime > outTime) {
                //  清除登录状态操作
                console.log('检测到您30分钟内无操作,请重新登录')
                logout()
                clearAll();
                clearInterval(Timer);
            }
            // else {
            //     console.log("refreshToken:", new Date().toLocaleTimeString());
            // }
    }, diff);
}

// 清除所有监听和token，并暴露
export function clearAll() {
    // console.log("log out:", new Date().toLocaleTimeString());
    document.removeEventListener('mouseover', resetlastTime, true);
    document.removeEventListener('keydown', resetlastTime, true);
    document.removeEventListener('mousedown', resetlastTime, true);
}




// WEBPACK FOOTER //
// ./src/utils/listeningToUserActions.js